import React, { useContext } from "react";
import { defaultProfileImage } from "../DefaultImage";
import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";
import { TbArrowsExchange } from "react-icons/tb";
import ExchangeContact from "../../Common/exchangeContactModal/ExchangeContact";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../../helpers/tapCountMutation";
function ProfileCardIconic({ card, Highlightcolor, Textcolor, preview }) {
  // const Highlightcolor = card?.colorCode ? card?.colorCode : "#1A1F23";
  // const Textcolor = card?.textColor ? card?.textColor : "#FFFFFF";
  const Iconcolor = card?.iconBgColor ? card?.iconBgColor : "#FFFFFF";
  // const BgColor = card?.bgColor ? card?.bgColor : "";
  const BtIColor = card?.btIconColor ? card?.btIconColor : "#000000";

  const [cardData] = useContext(CardContext)
  const { profileImage, personalDetails, contactDetails, vCard, checkProfile } = cardData

  const array = personalDetails?.name ? personalDetails?.name?.split(" ") : "";
  const exchangeButton = (
    <button
      className="flex justify-center items-center text-[12px] p-2 gap-3 h-[45px] rounded-[6px] w-full"
      style={{
        border: `2px solid ${Highlightcolor || "black"}`,
        color: Highlightcolor || "black",
      }}
    >
      <TbArrowsExchange className="w-4 h-4" />
      Exchange Contacts
    </button>
  )

  function isDarkColor(color) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
  }

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };

  return (
    <>
      <div className="iconictheme_profilecard flex items-end relative">
        <div className="ml-3 w-[127px]  ml-3 rounded-[8px] border-[2px] border-white -mt-[40px]">
          {profileImage ? (
            <img
              src={profileImage}
              alt=""
            />
          ) : (
            <img src={defaultProfileImage} alt="" />
          )}
        </div>
        <div className="ml-2 grid pr-4 content-center">
          <p
            className=" font-bold text-[24px] mb-2"
            style={{
              color: `${Textcolor ? Textcolor : ""}`,
              width: `${!checkProfile ? "max-content" : ""}`,
              fontSize: `${array[0]?.length > 9 ||
                array[1]?.length > 9 ||
                array[2]?.length > 9
                ? "20px"
                : ""
                }`,
            }}
          >
            {" "}
            {personalDetails?.name ? personalDetails.name : "Name"}
          </p>
          <p className="text-black font-medium leading-5 pb-0 m-0 text-[14px]" style={{    color: `${Textcolor ? Textcolor : ""}`,}}>
            {personalDetails?.companyDesignation
              ? personalDetails.companyDesignation
              : "Designation"}
          </p>
        </div>
      </div>
      <div className="pl-5 pr-5">
        <p className="text-black font-normal mt-5 leading-5  text-[14px] whitespace-pre-line" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
          <div className="flex mb-3 items-center gap-2" >
            <p className="font-semibold  text-[16px]" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>About</p>
            <p
              style={{
                borderBottom: `3px solid ${Highlightcolor ? Highlightcolor : "black"
                  }`,
                height: "4px",
                // marginTop: "18px",
              }}
            >
              &nbsp; &nbsp; &nbsp;{" "}
            </p>
          </div>
          {personalDetails?.about}
        </p>
      </div>
      <div className="flex justify-between w-full mt-2 p-3 gap-2">
        <Link
          onClick={() => handleTap('saveContact')}
          to={`${preview ? vCard : ""}`}
          // target={`${preview ? "_blank" : ""}`}
          className="blk-btn w-1/2"
        >
          <button
            className="flex justify-center items-center p-2 text-[12px] gap-2 h-[45px] rounded-[6px] w-full"
            style={{
              background: Highlightcolor || "black",
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.833 9.16683H10.833V4.16683C10.833 3.94582 10.7452 3.73385 10.5889 3.57757C10.4326 3.42129 10.2207 3.3335 9.99967 3.3335C9.77866 3.3335 9.5667 3.42129 9.41042 3.57757C9.25414 3.73385 9.16634 3.94582 9.16634 4.16683V9.16683H4.16634C3.94533 9.16683 3.73337 9.25463 3.57709 9.41091C3.42081 9.56719 3.33301 9.77915 3.33301 10.0002C3.33301 10.2212 3.42081 10.4331 3.57709 10.5894C3.73337 10.7457 3.94533 10.8335 4.16634 10.8335H9.16634V15.8335C9.16634 16.0545 9.25414 16.2665 9.41042 16.4228C9.5667 16.579 9.77866 16.6668 9.99967 16.6668C10.2207 16.6668 10.4326 16.579 10.5889 16.4228C10.7452 16.2665 10.833 16.0545 10.833 15.8335V10.8335H15.833C16.054 10.8335 16.266 10.7457 16.4223 10.5894C16.5785 10.4331 16.6663 10.2212 16.6663 10.0002C16.6663 9.77915 16.5785 9.56719 16.4223 9.41091C16.266 9.25463 16.054 9.16683 15.833 9.16683Z"
                fill={isDarkColor(Highlightcolor) ? "white" : "black"}
              />
            </svg>
            <span
              className="text-[12px]"
              style={{
                color: isDarkColor(Highlightcolor) ? "white" : "black",
              }}
            >
              Add to contacts
            </span>
          </button>
        </Link>
        {card?.exchangeContact?.show ?
          <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
          : ""
        }

      </div>


    </>
  );
}

export default ProfileCardIconic;
